// Import all path collections
import { commonPaths } from './common';
import { ticketPaths } from './ticket';
import { administrationPaths } from './administration';
import { masterDataPaths } from './masterData';
import { hrTicketPaths } from './hrTicket';
import { miscPaths } from './misc';

// Export types
export type { PathType } from './types';
export { getPath } from './types';

// Combine all paths into one object
const urlPath = {
  ...commonPaths,
  ...ticketPaths,
  ...administrationPaths,
  ...masterDataPaths,
  ...hrTicketPaths,
  ...miscPaths
};

export default urlPath;

// Also export individual path collections for specific use cases
export { commonPaths, ticketPaths, administrationPaths, masterDataPaths, hrTicketPaths, miscPaths };
